import axiosInstance from '../../../config/axiosInstance';
const  JobCommentService = {
    async GetAllJobComments(redirectCallback,IssueID) {
        try {           
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Job/GetAllJobComments?IssueID=${IssueID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteJobComments(ID,redirectCallback) {
        try {           
            const response = await axiosInstance.get(`/Job/DeleteJobComments?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    }
};

export default JobCommentService;